import React from 'react';
import { Form, Input, InputNumber, Modal } from 'antd';

const SegmentEditModal = ({ visible, onOk, onCancel, form }) => {
    return (
        <Modal
            title="Edit Segment"
            open={visible}
            onOk={onOk}
            onCancel={onCancel}
            destroyOnClose
        >
            <Form form={form} layout="vertical" initialValues={{ name: '', minutes: 10, goal: '' }}>
                <Form.Item name="name" label="Segment Name" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>
                <Form.Item name="minutes" label="Minutes" rules={[{ required: true, type: 'number' }]}>
                    <InputNumber min={1} max={180} style={{ width: '100%' }} />
                </Form.Item>
                <Form.Item name="goal" label="Goal">
                    <Input.TextArea autoSize={{ minRows: 2, maxRows: 5 }} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default SegmentEditModal;
